import { PluginEquifaxPpsrSerialNumberSearchRequest } from '../../../types/plugins';
import { ConstructPost } from '../../types/ConstructPost';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { PLUGIN_BASE_PATH } from '../constants/pluginBasePath';

export const runEquifaxPpsrSerialNumberSearchRequest = (
  constructPost: ConstructPost,
  data: PluginEquifaxPpsrSerialNumberSearchRequest,
): Promise<NonPaginatedResponse<null> | undefined> =>
  constructPost<NonPaginatedResponse<null>>(
    `${PLUGIN_BASE_PATH}/equifax-ppsr-serial-number-search-request`,
    { data },
    { preventDefaultErrorToast: true },
  );
